import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import {
  IACHVendorEmail,
  IACHNotificationBatch,
  IPendingNotifications,
  IPostNotification,
  IResponse
} from '../models';

const base = `/api/batch-payments/notifications`;

export const getACHNotifications = async (filters?: {
  page?: number;
  perPage: number;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IResponse<IACHNotificationBatch[]>> => {
  try {
    const { data } = await axios.get(`${base}`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getACHNotifications failed');
    return Promise.reject(error);
  }
};

export const getPendingACHNotifications = async (filters?: {
  page?: number;
  perPage: number;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IResponse<IPendingNotifications[]>> => {
  try {
    const { data } = await axios.get(`${base}/pending`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getPendingACHNotifications failed');
    return Promise.reject(error);
  }
};

export const createNewACHNotification = async (payload: IPostNotification): Promise<any> => {
  try {
    const { data } = await axios.post(`${base}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload
      },
      'createNewACHNotification failed'
    );
    return error.response.data;
  }
};

export const resendACHNotification = async (id: string | number): Promise<any> => {
  try {
    const { data } = await axios.post(`${base}/${id}`);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          id
        }
      },
      'resendACHNotification failed'
    );
    return Promise.reject(error);
  }
};

export const downloadACHNotificationPDF = async (
  id: string | number,
  vendorSageId: number
): Promise<any> => {
  try {
    const { data } = await axios.get(`${base}/vendors/${id}/vendors/${vendorSageId}`, {
      responseType: 'blob'
    });
    return data;
  } catch (error: any) {
    logError(error, 'downloadACHNotificationPDF failed');
    return error.response.data;
  }
};

export const adminDownloadACHNotificationPDF = async (
  id: string | number,
  vendorSageId: number
): Promise<any> => {
  try {
    const { data } = await axios.get(`${base}/${id}/vendors/${vendorSageId}`, {
      responseType: 'blob'
    });
    return data;
  } catch (error: any) {
    logError(error, 'downloadACHNotificationPDF failed');
    return error.response.data;
  }
};

export const getVendorEmails = async (
  batchId: number | string,
  filters?: {
    sortBy?: 'Vendor' | 'VendorAchEmail' | 'VendorSageId';
    sortDirection?: 'Asc' | 'Desc' | string;
    page?: number;
    perPage?: number;
  }
): Promise<IResponse<IACHVendorEmail[]>> => {
  try {
    const { data } = await axios.get(`${base}/pending/${batchId}`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error: any) {
    logError(error, 'getVendorEmails failed');
    return error.response.data;
  }
};
